<div class="branding-dialog">
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>palette</mat-icon>
    </div>
    <div class="header-text">
      <h2>Support Portal Branding</h2>
      <p>Customise how the User Support Portal looks for {{ data.project.name }}.</p>
    </div>
  </div>

  <!-- Live Preview Card -->
  <div class="preview-box" [style.background]="portalBgColor" [style.color]="portalTextColor">
    <div class="preview-brand">
      <div class="preview-badge">
        <mat-icon>volunteer_activism</mat-icon>
      </div>
      <div>
        <h3 class="preview-title">{{ portalTitle || 'Support Portal' }}</h3>
        <p class="preview-sub">Suggest features and pledge support</p>
      </div>
    </div>
    <button mat-flat-button [style.background]="portalPrimaryColor" style="color: #fff;">
      Suggest Task
    </button>
  </div>

  <form (ngSubmit)="onSubmit()" class="form-body">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Portal Title</mat-label>
      <input matInput [(ngModel)]="portalTitle" name="portalTitle" placeholder="e.g. Acme Support & Feedback Portal" />
    </mat-form-field>

    <div class="color-pickers-grid">
      <div class="color-picker-item">
        <label>Header Background</label>
        <div class="color-input-row">
          <input type="color" [(ngModel)]="portalBgColor" name="portalBgColor" />
          <input matInput [(ngModel)]="portalBgColor" name="portalBgColorText" class="hex-text" />
        </div>
      </div>

      <div class="color-picker-item">
        <label>Header Text Color</label>
        <div class="color-input-row">
          <input type="color" [(ngModel)]="portalTextColor" name="portalTextColor" />
          <input matInput [(ngModel)]="portalTextColor" name="portalTextColorText" class="hex-text" />
        </div>
      </div>

      <div class="color-picker-item">
        <label>Primary Action Color</label>
        <div class="color-input-row">
          <input type="color" [(ngModel)]="portalPrimaryColor" name="portalPrimaryColor" />
          <input matInput [(ngModel)]="portalPrimaryColor" name="portalPrimaryColorText" class="hex-text" />
        </div>
      </div>
    </div>

    <div class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</div>

    <div class="dialog-actions">
      <button mat-button type="button" (click)="onCancel()" [disabled]="isSubmitting">Cancel</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="isSubmitting">
        <span>Save Branding</span>
      </button>
    </div>
  </form>
</div>
